module.exports = __webpack_public_path__ + "img/tpunkt.bbed59f9.svg";